import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30af6050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = {
  key: 0,
  class: "exists-orders-badge"
}
const _hoisted_3 = {
  key: 0,
  class: "exists-orders-badge"
}

import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useCustomRouter } from "@/utils/router";
import { OrderType } from "@/types/order/Order";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderTab',
  props: {
  orderType: {
    type: String as PropType<OrderType>,
    required: true
  },
  existsLimitedOrder: {
    type: Boolean,
    required: true
  },
  existsIndividualOrder: {
    type: Boolean,
    required: true
  }
},
  emits: ["update:orderType"],
  setup(__props, { emit }) {



const { pushIgnoreError } = useCustomRouter();



const changeToPublic = async () => {
  await pushIgnoreError({
    name: "Search"
  });
};

const changeToLimited = async () => {
  await pushIgnoreError({
    name: "SearchLimitedOrders"
  });
};

const changeToIndividual = async () => {
  await pushIgnoreError({
    name: "SearchIndividualOfferOrders"
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tab-content", { 'tab-content-active': __props.orderType === 'public' }]),
      onClick: changeToPublic
    }, "\n      一般\n    ", 2),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass(["tab-content", { 'tab-content-active': __props.orderType === 'limited' }]),
      onClick: changeToLimited
    }, [
      _createVNode(FeatherIcon, {
        icon: "key",
        size: "16",
        class: "mr-2"
      }),
      _createTextVNode("\n      限定\n      "),
      (__props.existsLimitedOrder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass(["tab-content", { 'tab-content-active': __props.orderType === 'individual' }]),
      onClick: changeToIndividual
    }, [
      _createVNode(FeatherIcon, {
        icon: "award",
        size: "16",
        class: "mr-2"
      }),
      _createTextVNode("\n      指名\n      "),
      (__props.existsIndividualOrder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})